// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f56ff976","455":"1c461ab7","488":"c540e8ef","644":"f3153451"}[chunkId] + ".chunk.js";
};